export class Integracao {
    private id:            number;
    private nome:          string;
    private endereco:      string;
    private nro_ender:     string;
    private bairro:        string;
    private municipio:     number;
    private cidade:        string;
    private cnpj:          string;
    private contato:       string;
    private login:         string;
    private senha:         string;
    private usuario:       number;
    private data_lib:      string;
    private status:        string;

    constructor() {}

    public toJSON() {
        return {
            id:          this.id,
            nome:        this.nome,
            endereco:    this.endereco,
            nro_ender:   this.nro_ender,
            bairro:      this.bairro,
            municipio:   this.municipio,
            cidade:      this.cidade,
            cnpj:        this.cnpj,
            contato:     this.contato,
            login:       this.login,
            senha:       this.senha,
            usuario:     this.usuario,
            data_lib:    this.data_lib,
            status:      this.status
        };
    }

    public toClass(integracao) {
        this.id        = integracao.id;
        this.nome      = integracao.nome;
        this.endereco  = integracao.endereco;
        this.nro_ender = integracao.nro_ender;
        this.bairro    = integracao.bairro;
        this.municipio = integracao.municipio;
        this.cidade    = integracao.nome_cid;
        this.cnpj      = integracao.cnpj;
        this.contato   = integracao.contato;
        this.login     = integracao.login;
        this.senha     = integracao.senha;
        this.usuario   = integracao.usuario;
        this.data_lib  = integracao.data_lib;
        this.status    = integracao.status;
    }

}